// extracted by mini-css-extract-plugin
module.exports = {"component":"nFdHQCe4Dm39z5yO6ERaY","a":"_2esZY5hJl0GcXTKZB5eGLK","small":"_2tm2_ueQLTDRyRRp-mk_1i","light":"_2tvbYZMQCsqNKJ_uoBR2Ad"};